import React from 'react';
import PropTypes from 'prop-types';
import { propTypes } from '../../util/types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { Modal } from '../../components';
import { InviteTeamMemberForm } from '../../forms';
import classNames from 'classnames';

import css from './InviteTeamMemberModal.module.css';

/**
 * Invite someone to a production's or a Live Room's team: the reference form in a modal (plan 6i),
 * drawn as the dashboard's "Invite someone" modal (DashTeamInvite): the title beside the close
 * button, the fields, then Cancel and Send invite on the right.
 */
const InviteTeamMemberModal = props => {
  const {
    className,
    rootClassName,
    id,
    titleMsgId,
    descriptionMsgId,
    isOpen,
    onCloseModal,
    handleSubmit,
    currentUser,
    currentOrganizationProfile,
    team,
    listing,
    sendInviteInProgress,
    sendInviteError,
    onManageDisableScrolling,
    creditRolesConfigOptions,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const titleId = `${id}.title`;

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      ariaLabelledBy={titleId}
      usePortal
    >
      <h2 id={titleId} className={css.title}>
        <FormattedMessage id={titleMsgId ? titleMsgId : 'InviteTeamMemberModal.title'} />
      </h2>
      <p className={css.message}>
        <FormattedMessage
          id={descriptionMsgId ? descriptionMsgId : 'InviteTeamMemberModal.description'}
        />
      </p>
      <InviteTeamMemberForm
        key={isOpen ? 'open' : 'closed'}
        id="TeamPermissionPage.InviteTeamMemberForm"
        currentUser={currentUser}
        currentListing={listing}
        onSubmit={handleSubmit}
        team={team}
        currentOrganizationProfile={currentOrganizationProfile}
        sendInviteInProgress={sendInviteInProgress}
        sendInviteError={sendInviteError}
        creditRolesConfigOptions={creditRolesConfigOptions}
        onCancel={onCloseModal}
      />
    </Modal>
  );
};

const { arrayOf, string, bool, func } = PropTypes;

InviteTeamMemberModal.defaultProps = {
  className: null,
  rootClassName: null,

  titleMsgId: null,
  descriptionMsgId: null,

  listing: null,
  sendInviteInProgress: false,
  sendInviteError: null,
};

InviteTeamMemberModal.propTypes = {
  className: string,
  rootClassName: string,

  titleMsgId: string,
  descriptionMsgId: string,

  currentUser: propTypes.currentUser,
  listing: PropTypes.oneOfType([propTypes.listing, propTypes.ownListing]),
  team: arrayOf(propTypes.user),
  sendInviteInProgress: bool.isRequired,
  sendInviteError: propTypes.error,
  handleSubmit: func.isRequired,

  intl: intlShape.isRequired,
};

export default injectIntl(InviteTeamMemberModal);
